import consumer from './consumer';

// jQuery selectors
const $conferencePage = $("#conference-page");
const isConferencePage = $conferencePage.length > 0;

  // Early exit if it is not a conference page
(function () {
  if (!isConferencePage) return;

  // Sala "live" reutiliza o mesmo DOM; o fluxo é tratado em live_session_channel.js
  if ($conferencePage.data("liveSession") === true) return;

  let intervalCountdown;
  let intervalTimer = null;
  let conferenceChannel;
  let currentTime = 0;
  let isCountdownRunning = false;
  /** Evita POST duplicado para /conferences/start quando vários eventos Jitsi disparam. */
  let conferenceClockStarted = false;
  let conferenceStartRequestInFlight = false;
  let conferenceStartConflictRetries = 0;
  const CONFERENCE_START_MAX_CONFLICT_RETRIES = 120;
  /** start_time já recebido (broadcast/subscribe) mas ainda sem par no Jitsi — só aplicar quando ambos estiverem na sala. */
  let pendingConferenceTimerStart = null;
  /** Último start_time conhecido (DOM inicial ou broadcast) para retomar após pausa ou F5. */
  let lastKnownConferenceStartTime = null;

  // DOM elements
  const $countdownTimer = $('.countdown-control .countdown-timer');

  const $timer = $('#timer');
  const $connectionControl = $('.connection-control');
  const $countdownControl = $('.countdown-control');

  // Conference data
  const roomID = $conferencePage.data("conference-room-id");
  const partnerName = $conferencePage.data("partner-name");
  const partnerSlug = $conferencePage.data("partner-slug");
  const displayName = $conferencePage.data("display-name");
  const conferenceStartTime = $conferencePage.data("conference-start-time");
  let conferenceDuration = parseInt($conferencePage.data("conference-duration"), 10) || 0;

  if (conferenceStartTime != null && String(conferenceStartTime).trim().length > 0) {
    lastKnownConferenceStartTime = conferenceStartTime;
  }

  const authenticityToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  const walletExtensionEnabled =
    $conferencePage.attr("data-wallet-extension") === "true";
  const hasProfessionalNotePanel = document.getElementById('professional-note-box') !== null;

  const $extendStack = $("#conference-extend-stack");
  const $extendBannerInner = $("#conference-extend-banner");
  const extendOptionsEl = document.getElementById("conference-extend-options-json");
  const extendPackagesAllEl = document.getElementById("conference-extend-packages-all-json");
  let extendOptions = [];
  let allExtensionPackages = [];
  if (extendOptionsEl) {
    try {
      const parsed = JSON.parse(extendOptionsEl.textContent || "[]");
      extendOptions = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      extendOptions = [];
    }
  }
  if (extendPackagesAllEl) {
    try {
      const parsed = JSON.parse(extendPackagesAllEl.textContent || "[]");
      allExtensionPackages = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      allExtensionPackages = [];
    }
  }

  /** Minutos escolhidos antes do PIX; após pagamento confirmado, estende a conferência automaticamente. */
  let pendingExtensionMinutesAfterPix = null;

  /** null = nunca clicou em "Agora não"; após fechar, guarda o "minuto cheio" (1–5) para reaparecer ao descer 1 min. */
  let extendBannerDismissedMinuteBucket = null;
  let lastRemainingSeconds = Infinity;
  let oneMinuteWarningShown = false;

  let extendSuccessHideTimeout = null;

  function getExtendUiRoot() {
    return $extendStack.length ? $extendStack : $extendBannerInner;
  }

  /** Minutos permitidos para extensão: alinhados a SessionCallPackages (DOM + pacotes PIX). */
  function readExtensionAllowedMinutesFromDom() {
    const el = document.getElementById("conference-extend-allowed-minutes-json");
    if (!el) return [];
    try {
      const arr = JSON.parse(el.textContent || "[]");
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function getExtensionAllowedMinuteSet() {
    const set = new Set();
    (allExtensionPackages || []).forEach(function (p) {
      const m = p.minutes != null ? p.minutes : p["minutes"];
      if (m != null) set.add(parseInt(m, 10));
    });
    if (set.size > 0) return set;
    readExtensionAllowedMinutesFromDom().forEach(function (m) {
      set.add(parseInt(m, 10));
    });
    return set;
  }

  function isValidExtensionMinutes(minutes) {
    const m = parseInt(minutes, 10);
    if (!Number.isFinite(m)) return false;
    return getExtensionAllowedMinuteSet().has(m);
  }

  function getRemainingSeconds() {
    return Math.max(0, conferenceDuration * 60 - currentTime);
  }

  /** Minutos “cheios” restantes (1–5) dentro dos últimos 300 s; 0 se tempo esgotado. */
  function extendMinuteBucket(remainingSeconds) {
    if (remainingSeconds <= 0) return 0;
    return Math.ceil(remainingSeconds / 60);
  }

  /**
   * Últimos 5 min (extender) e último minuto (alerta). Reaparece após F5, e após "Agora não"
   * quando o tempo desce de faixa (ex.: fechou com ~5 min → mostra de novo com ~4 min).
   */
  function checkConferenceTimerAlerts() {
    const remainingSeconds = Math.max(0, conferenceDuration * 60 - currentTime);
    const prevRemaining = lastRemainingSeconds;

    if (
      walletExtensionEnabled &&
      getExtendUiRoot().length &&
      remainingSeconds > 0 &&
      remainingSeconds <= 300
    ) {
      const $root = getExtendUiRoot();
      const alreadyVisible = $root.is(":visible");
      const currB = extendMinuteBucket(remainingSeconds);
      const prevB =
        prevRemaining === Infinity ? null : extendMinuteBucket(prevRemaining);

      let shouldShowExtend = false;

      if (!alreadyVisible && currB >= 1 && currB <= 5) {
        if (extendBannerDismissedMinuteBucket === null) {
          if (
            prevRemaining === Infinity &&
            remainingSeconds <= 300 &&
            remainingSeconds > 0
          ) {
            shouldShowExtend = true;
          } else if (prevRemaining > 300 && remainingSeconds <= 300) {
            shouldShowExtend = true;
          }
        } else if (
          prevB !== null &&
          prevB > currB &&
          currB === extendBannerDismissedMinuteBucket - 1
        ) {
          shouldShowExtend = true;
        }
      }

      if (shouldShowExtend) {
        showExtendBanner();
      }
    }

    // Evita toast "1 minuto" em cima da barra de extensão (últimos 5 min já comunicam o fim).
    const extendBarVisible =
      walletExtensionEnabled &&
      getExtendUiRoot().length &&
      getExtendUiRoot().is(":visible");

    if (
      !oneMinuteWarningShown &&
      !extendBarVisible &&
      prevRemaining > 60 &&
      remainingSeconds <= 60 &&
      remainingSeconds > 0
    ) {
      oneMinuteWarningShown = true;
      if (window.FullscreenUtils && typeof window.FullscreenUtils.exitFullscreen === "function") {
        window.FullscreenUtils.exitFullscreen();
      }
      const msg =
        remainingSeconds === 60
          ? "Sua conferência será encerrada em 1 minuto."
          : "Falta menos de 1 minuto para encerrar a conferência.";
      showAlert(msg);
    }

    lastRemainingSeconds = remainingSeconds;
  }

  function updateWalletBalanceDisplay(formatted, numericBalance) {
    const $el = $("#conference-extend-wallet-balance");
    if ($el.length && formatted) {
      $el.text(formatted);
    }
    if (numericBalance != null && $extendStack.length) {
      const n = parseFloat(numericBalance, 10);
      if (Number.isFinite(n)) {
        $extendStack.attr("data-wallet-balance", String(n));
      }
    }
  }

  function getWalletBalanceNumeric() {
    if (!$extendStack.length) return 0;
    const raw = $extendStack.attr("data-wallet-balance");
    const n = parseFloat(raw, 10);
    return Number.isFinite(n) ? n : 0;
  }

  function getExtensionCostForMinutes(minutes) {
    const pkg = allExtensionPackages.find(function (p) {
      const m = p.minutes != null ? p.minutes : p["minutes"];
      return m === minutes;
    });
    if (!pkg) return null;
    const c = pkg.cost != null ? pkg.cost : pkg["cost"];
    if (c == null) return null;
    const n = typeof c === "number" ? c : parseFloat(String(c).replace(",", "."), 10);
    return Number.isFinite(n) ? n : null;
  }

  function pixRechargeEnabledOnExtend() {
    return $extendStack.data("pix-recharge") === true;
  }

  function roundMoney2(n) {
    return Math.round(Number(n) * 100) / 100;
  }

  function extendSuccessDetailText(minutes) {
    const n = parseInt(minutes, 10);
    if (!Number.isFinite(n) || n <= 0) {
      return "O tempo total da conferência foi atualizado.";
    }
    if (n === 1) {
      return "Foi adicionado 1 minuto à sua conferência.";
    }
    return `Foram adicionados ${n} minutos à sua conferência.`;
  }

  function resetExtendBannerPanels() {
    $("#conference-extend-banner-main").removeClass("d-none");
    $("#conference-extend-success-panel").addClass("d-none");
  }

  function applyExtendResponse(res) {
    if (!res || !res.ok || !res.total_time_in_minutes) return false;
    const fallbackMins = parseInt($("#conference-extend-minutes").val(), 10);
    const fromServer = parseInt(res.additional_minutes, 10);
    const additionalMinutes = Number.isFinite(fromServer) && fromServer > 0
      ? fromServer
      : (Number.isFinite(fallbackMins) && fallbackMins > 0 ? fallbackMins : null);

    conferenceDuration = parseInt(res.total_time_in_minutes, 10);
    $conferencePage.data("conference-duration", conferenceDuration);
    if (Array.isArray(res.extend_options)) {
      extendOptions = res.extend_options;
      allExtensionPackages = res.extend_options;
    }
    if (res.wallet_balance_formatted) {
      updateWalletBalanceDisplay(res.wallet_balance_formatted, res.wallet_balance);
    }

    $("#conference-extend-success-detail").text(
      extendSuccessDetailText(additionalMinutes)
    );
    $("#conference-extend-banner-main").addClass("d-none");
    $("#conference-extend-success-panel").removeClass("d-none");
    getExtendUiRoot().show();
    $("#conference-extend-banner-dim").removeClass("d-none");

    if (extendSuccessHideTimeout) {
      clearTimeout(extendSuccessHideTimeout);
      extendSuccessHideTimeout = null;
    }
    extendSuccessHideTimeout = setTimeout(function () {
      extendSuccessHideTimeout = null;
      hideExtendBanner();
      resetExtendPromptForNewSlice();
    }, 3200);
    return true;
  }

  function renderExtendBannerContent() {
    if (!getExtendUiRoot().length) return;

    resetExtendBannerPanels();

    const $lead = $("#conference-extend-lead");
    const $select = $("#conference-extend-minutes");
    const $formWrap = $("#conference-extend-form-wrap");
    const $confirm = $("#conference-extend-confirm");
    const $pixHint = $("#conference-extend-pix-hint");

    $lead.text(
      "Faltam menos de 5 minutos para terminar a conferência. Deseja estender o tempo?"
    );

    if ($("#conference-extend-profile-link-msg").length) {
      $pixHint.addClass("d-none");
      return;
    }

    $select.empty();
    const packages =
      extendOptions.length > 0 ? extendOptions : allExtensionPackages;
    $("#conference-extend-profile-link-msg").addClass("d-none");
    packages.forEach((opt) => {
      const mins = opt.minutes != null ? opt.minutes : opt["minutes"];
      const label =
        opt.label != null ? opt.label : `${mins} minutos`;
      $select.append($("<option></option>").attr("value", mins).text(label));
    });
    $formWrap.removeClass("d-none");
    $confirm.removeClass("d-none");
    if (pixRechargeEnabledOnExtend()) {
      $pixHint.removeClass("d-none");
    } else {
      $pixHint.addClass("d-none");
    }
  }

  function fetchExtendMetaFromServer() {
    return $.getJSON(`/conferences/${roomID}/extend_meta`);
  }

  window.__conferenceExtendAfterPixPaid = function () {
    fetchExtendMetaFromServer()
      .done(function (data) {
        extendOptions = data.extend_options || [];
        if (extendOptions.length) {
          allExtensionPackages = extendOptions;
        }
        if (data.wallet_balance_formatted) {
          updateWalletBalanceDisplay(
            data.wallet_balance_formatted,
            data.wallet_balance
          );
        }

        const pending = pendingExtensionMinutesAfterPix;
        const validPending =
          pending != null && isValidExtensionMinutes(pending);

        function refreshBannerIfNeeded() {
          renderExtendBannerContent();
          const rem = getRemainingSeconds();
          if (rem <= 300 && rem > 0) {
            showExtendBanner();
          }
        }

        if (validPending) {
          pendingExtensionMinutesAfterPix = null;
          const $btn = $("#conference-extend-confirm");
          $btn.prop("disabled", true);
          $.ajax({
            url: `/conferences/extend/${roomID}`,
            method: "POST",
            data: {
              authenticity_token: authenticityToken,
              additional_minutes: pending,
            },
          })
            .done(function (res) {
              if (applyExtendResponse(res)) {
                return;
              }
              pendingExtensionMinutesAfterPix = pending;
              refreshBannerIfNeeded();
            })
            .fail(function (xhr) {
              const msg =
                (xhr.responseJSON && xhr.responseJSON.error) ||
                "Não foi possível estender. Confirme novamente na barra.";
              showAlert(msg);
              pendingExtensionMinutesAfterPix = pending;
              refreshBannerIfNeeded();
            })
            .always(function () {
              $btn.prop("disabled", false);
            });
        } else {
          refreshBannerIfNeeded();
        }
      })
      .fail(function () {
        showAlert(
          "Saldo atualizado. Se a extensão não aparecer, atualize a página."
        );
      });
  };

  function secondsTimeSpanToHMS(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  function showAlert(message) {
    const $alert = $(`
      <div class="alert alert-timer alert-light shadow-sm alert-dismissible text-center show fade" role="alert">
        ${message}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    `);

    $conferencePage.append($alert.slideDown().delay(10000).slideUp());
  }

  function updateCountdownTimer(totalTime) {
    if (isCountdownRunning) return;

    isCountdownRunning = true;

    $countdownTimer.html(totalTime);

    intervalCountdown = setInterval(() => {
      $countdownTimer.html(totalTime--);

      if (totalTime < 0) {
        clearInterval(intervalCountdown);

        isCountdownRunning = false;

        setTimeout(() => {
          $countdownTimer.html('Ligação finalizada!');
          endConference();
        }, 1000);
      }
    }, 1000);
  }

  function setVisibility($element, isVisible) {
    isVisible ? $element.show() : $element.hide();
  }

  function endConference() {
    $.post(`/conferences/finish/${roomID}`, {
      authenticity_token: authenticityToken
    });
  }

  function conferenceTimer(startTime) {
    clearInterval(intervalTimer);
    intervalTimer = null;

    if (startTime != null && String(startTime).trim().length > 0) {
      lastKnownConferenceStartTime = startTime;
    }

    let startDate;
    
    // Tentar múltiplos formatos de data para compatibilidade com Safari
    if (!startTime || startTime === '') {
      console.warn('startTime vazio, usando data atual');
      startDate = new Date();
    } else if (typeof startTime === 'string') {
      // Remover timezone e normalizar formato para Safari
      const normalizedTime = startTime.replace(' -0300', '').replace(' ', 'T');
      startDate = new Date(normalizedTime);
      
      // Se ainda não funcionou, tentar formato ISO direto
      if (isNaN(startDate.getTime())) {
        startDate = new Date(startTime);
      }
    } else {
      startDate = new Date(startTime);
    }

    if (isNaN(startDate.getTime())) {
      console.error('Data inválida:', startTime);
      startDate = new Date(); // Fallback para data atual
    }

    // Calcular o tempo inicial uma vez
    const currentDate = new Date();
    const differenceInMilliseconds = currentDate - startDate;
    currentTime = Math.max(0, Math.floor(differenceInMilliseconds / 1000));

    // Após F5: últimos 5 min / último minuto sem esperar o 1º tick do intervalo
    checkConferenceTimerAlerts();

    // Timer baseado em incremento com sincronização periódica
    intervalTimer = setInterval(() => {
      currentTime += 1;

      $timer.html(secondsTimeSpanToHMS(currentTime));
      setVisibility($connectionControl, false);

      checkConferenceTimerAlerts();

      // Verifica se o tempo total da conferência foi atingido
      if (currentTime >= conferenceDuration * 60) {
        clearInterval(intervalTimer);
        endConference();
      }
    }, 1000);
  }

  function hideExtendBanner() {
    if (extendSuccessHideTimeout) {
      clearTimeout(extendSuccessHideTimeout);
      extendSuccessHideTimeout = null;
    }
    pendingExtensionMinutesAfterPix = null;
    resetExtendBannerPanels();
    const $root = getExtendUiRoot();
    if ($root.length) {
      $root.hide();
    }
    $("#conference-extend-banner-dim").addClass("d-none");
  }

  function showExtendBanner() {
    if (!getExtendUiRoot().length) return;

    renderExtendBannerContent();
    $("#conference-extend-banner-dim").removeClass("d-none");
    getExtendUiRoot().show();
  }

  function resetExtendPromptForNewSlice() {
    extendBannerDismissedMinuteBucket = null;
    lastRemainingSeconds = Infinity;
    oneMinuteWarningShown = false;
  }

  $(document).on("click", "#conference-extend-dismiss", function () {
    extendBannerDismissedMinuteBucket = extendMinuteBucket(getRemainingSeconds());
    hideExtendBanner();
  });

  $(document).on("show.bs.modal", "#pix-modal", function () {
    $("#conference-extend-banner-dim").addClass("d-none");
  });

  $(document).on("hidden.bs.modal", "#pix-modal", function () {
    if (getExtendUiRoot().is(":visible")) {
      $("#conference-extend-banner-dim").removeClass("d-none");
    }
  });

  $(document).on("click", "#conference-extend-confirm", function () {
    const $btn = $(this);
    const minutes = parseInt($("#conference-extend-minutes").val(), 10);
    if (!minutes || !isValidExtensionMinutes(minutes)) return;

    const cost = getExtensionCostForMinutes(minutes);
    if (cost == null || cost <= 0) return;

    const balance = getWalletBalanceNumeric();
    const shortfall = roundMoney2(Math.max(0, cost - balance));
    const needsPix = shortfall >= 0.01;

    if (needsPix) {
      if (!pixRechargeEnabledOnExtend()) {
        showAlert(
          "Saldo insuficiente para este tempo adicional. Escolha um pacote menor ou recarregue a carteira."
        );
        return;
      }

      pendingExtensionMinutesAfterPix = minutes;

      $btn.prop("disabled", true);
      const gen =
        window.pixRecharge &&
        typeof window.pixRecharge.generatePixFromExtensionCost === "function"
          ? window.pixRecharge.generatePixFromExtensionCost(shortfall)
          : null;
      if (gen && typeof gen.finally === "function") {
        gen.finally(function () {
          $btn.prop("disabled", false);
        });
      } else {
        $btn.prop("disabled", false);
      }
      return;
    }

    $btn.prop("disabled", true);
    $.ajax({
      url: `/conferences/extend/${roomID}`,
      method: "POST",
      data: {
        authenticity_token: authenticityToken,
        additional_minutes: minutes,
      },
    })
      .done(function (res) {
        applyExtendResponse(res);
      })
      .fail(function (xhr) {
        const msg =
          (xhr.responseJSON && xhr.responseJSON.error) ||
          "Não foi possível estender. Tente novamente.";
        showAlert(msg);
      })
      .always(function () {
        $btn.prop("disabled", false);
      });
  });

  // Function to start the conference
  function actionStartConference() {
    conferenceChannel = consumer.subscriptions.create({ channel: 'ConferenceChannel', room_id: roomID }, {
      connected() {
        clearInterval(intervalCountdown);
        setVisibility($timer, true);
        // Não forçar overlay após reconexão ActionCable se o par já estiver na sala (evita ficar preso em “aguarde…”).
        setVisibility($connectionControl, getParticipants().length === 0);

        isCountdownRunning = false;

        const domStartPresent =
          conferenceStartTime != null &&
          String(conferenceStartTime).trim().length > 0;
        if (domStartPresent) {
          queueOrRunConferenceTimer(conferenceStartTime);
        }

        // Subscrição ActionCable acabou de ficar activa — o servidor conta presença na sala por isto.
        maybeBeginConferenceClockAfterBothJoined();
      },

      received(data) {
        if (data.action == 'timer') {
          const start = data.start_time || data.startTime;
          queueOrRunConferenceTimer(start);
        }
        if (data.action == 'extended' && data.total_time_in_minutes != null) {
          conferenceDuration = parseInt(data.total_time_in_minutes, 10);
          $conferencePage.data("conference-duration", conferenceDuration);
          const successVisible =
            $("#conference-extend-success-panel").length &&
            !$("#conference-extend-success-panel").hasClass("d-none");
          if (!successVisible) {
            hideExtendBanner();
            resetExtendPromptForNewSlice();
          }
        }
      }
    });
  }

  // NEW CONFERENCE

  // A URL base do seu servidor Jitsi
  const domain = 'meet.helpcam.com';

  const tokenJWT = window.jitsiToken;

  // Nome da sala (deve ser único, e.g., baseado no ID da reunião)
  const roomName = `helpcam-${roomID}`;

  // Opções da conferência
  const options = {
    roomName: roomName,
    width: '100%',
    height: '100%',
    parentNode: document.querySelector('#jitsi-container'),
    userInfo: {
      displayName: displayName
    },
    configOverwrite: {
      requireTokenAuth: true,
      startWithAudioMuted: false,
      disableProfile: true,
      disableModeratorIndicator: true,
      prejoinConfig: {
        enabled: true,
        hideExtraJoinButtons: ['no-audio']
      },
      conferenceInfo: {
        autoHide: [],
      },
      hideConferenceSubject: '',
      gravatar: {
        disabled: true
      },
      deeplinking: { disabled: true },
      disableDeepLinking: true,
      enableWelcomePage: false,
      ...(hasProfessionalNotePanel ? {
        customToolbarButtons: [{
          id: 'session-notes',
          icon: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23fff%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Crect x=%229%22 y=%222%22 width=%226%22 height=%224%22 rx=%221%22/%3E%3Cpath d=%22M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2%22/%3E%3Cpath d=%22M9 12h6%22/%3E%3Cpath d=%22M9 16h6%22/%3E%3C/svg%3E',
          text: 'Notas'
        }]
      } : {}),
      toolbarButtons: [
        'camera',
        'desktop',
        'tileview',
        'fullscreen',
        'highlight',
        'microphone',
        'noisesuppression',
        'select-background',
        'shareaudio',
        'sharedvideo',
        'toggle-camera',
        'hangup',
        'chat',
        ...(hasProfessionalNotePanel ? ['session-notes'] : [])
      ],
      buttonsWithNotifyClick: [
        { key: 'chat', preventExecution: true },
        ...(hasProfessionalNotePanel ? [{ key: 'session-notes', preventExecution: true }] : []),
        { key: 'hangup-menu', preventExecution: true }
      ],
    },
    interfaceConfigOverwrite: {
      HIDE_NO_AUDIO_OPTION: true,
      HIDE_ROOMNAME_ON_JOIN: true,
      SHOW_JITSI_WATERMARK: false,
      SHOW_WATERMARK_FOR_GUESTS: false,
      DEFAULT_BACKGROUND: '#1F9EDE',
    },
    jwt: tokenJWT,
    lang: 'ptBR'
  };

  // 3. Crie a Conferência
  const api = new JitsiMeetExternalAPI(domain, options);

  function reflowJitsiLayout() {
    // Solicita recálculo de layout sem manipular largura do iframe (evita desalinhamento).
    window.dispatchEvent(new Event('resize'));
  }

  window.addEventListener('professional-notes-panel-toggled', function () {
    reflowJitsiLayout();
    setTimeout(reflowJitsiLayout, 120);
  });

  /** Supressão de ruído desativada ao entrar; o utilizador pode ativar na toolbar. */
  function applyDefaultNoiseSuppression() {
    try {
      api.executeCommand('setNoiseSuppressionEnabled', { enabled: false });
    } catch (e) {
      /* ignore */
    }
  }

  function notifyConferenceStartOnServer() {
    if (conferenceClockStarted || conferenceStartRequestInFlight) return;
    conferenceStartRequestInFlight = true;

    $.ajax({
      url: `/conferences/start/${roomID}`,
      method: 'POST',
      data: { authenticity_token: authenticityToken },
    })
      .done(function () {
        conferenceClockStarted = true;
        conferenceStartConflictRetries = 0;
      })
      .fail(function (xhr) {
        if (xhr.status === 409 && hasRemoteParticipant()) {
          if (conferenceStartConflictRetries < CONFERENCE_START_MAX_CONFLICT_RETRIES) {
            conferenceStartConflictRetries += 1;
            setTimeout(notifyConferenceStartOnServer, 350);
          }
        }
      })
      .always(function () {
        conferenceStartRequestInFlight = false;
      });
  }

  function startClock() {
    notifyConferenceStartOnServer();
  }

  function startCountdown() {
    window.FullscreenUtils.exitFullscreen();
    setVisibility($connectionControl, false);
    setVisibility($countdownControl, true);
    $countdownTimer.html('60');
    updateCountdownTimer(59);
  }

  function stopCountdown() {
    setVisibility($countdownControl, false);
    $countdownTimer.html('60');
    clearInterval(intervalCountdown);

    isCountdownRunning = false;
  }

  /** Participantes remotos (getParticipantsInfo inclui o local como participantId === 'local'). */
  function getParticipants() {
    const allParticipants = api.getParticipantsInfo();
    return allParticipants.filter((p) => p.participantId !== 'local');
  }

  /** Pelo menos um participante além do utilizador local (chamada 1:1 → dois na sala). */
  function hasRemoteParticipant() {
    try {
      return getParticipants().length >= 1;
    } catch (e) {
      return false;
    }
  }

  /**
   * Cronómetro só avança com os dois na sala: se já houver start_time (HTML ou broadcast)
   * mas o par ainda não entrou no Jitsi, fica em espera.
   */
  function queueOrRunConferenceTimer(start) {
    if (start == null || String(start).trim() === '') return;
    lastKnownConferenceStartTime = start;
    if (hasRemoteParticipant()) {
      pendingConferenceTimerStart = null;
      conferenceTimer(start);
    } else {
      pendingConferenceTimerStart = start;
    }
  }

  function maybeBeginConferenceClockAfterBothJoined() {
    if (!hasRemoteParticipant()) return;

    stopCountdown();
    setVisibility($connectionControl, false);

    if (pendingConferenceTimerStart) {
      conferenceTimer(pendingConferenceTimerStart);
      pendingConferenceTimerStart = null;
      return;
    }

    const domHasStart =
      conferenceStartTime != null && String(conferenceStartTime).trim().length > 0;
    const serverKnown = (domHasStart && conferenceStartTime) || lastKnownConferenceStartTime;

    if (!conferenceClockStarted && !serverKnown) {
      startClock();
      return;
    }

    if (serverKnown) {
      conferenceTimer(serverKnown);
    }
  }

  api.on('toolbarButtonClicked', ({ key }) => {
    if (key === 'chat') {
      window.FullscreenUtils.exitFullscreen();
      window.openChatPopup(partnerSlug, partnerName);
    }

    if (key === 'session-notes' && hasProfessionalNotePanel) {
      window.FullscreenUtils.exitFullscreen();
      if (typeof window.openProfessionalNotePanel === 'function') {
        window.openProfessionalNotePanel();
      } else {
        const fallbackButton = document.querySelector('.js-toggle-professional-note-panel');
        if (fallbackButton) fallbackButton.click();
      }
    }

    if (key === 'hangup-menu') {
      endConference();
    }
  });

  api.on('videoConferenceJoined', (event) => {
    applyDefaultNoiseSuppression();
    setTimeout(applyDefaultNoiseSuppression, 800);
    setTimeout(reflowJitsiLayout, 300);

    actionStartConference();

    function revealIfPartnerAlreadyPresent() {
      maybeBeginConferenceClockAfterBothJoined();
    }
    revealIfPartnerAlreadyPresent();
    setTimeout(revealIfPartnerAlreadyPresent, 400);
  });

  api.on('participantJoined', (event) => {
    maybeBeginConferenceClockAfterBothJoined();
  });

  api.on('participantLeft', (event) => {
    if (getParticipants().length === 0) {
      startCountdown();
    }
  });
})();
